"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeHeaderActivation = void 0;
const react_hook_form_1 = require("react-hook-form");
const employee_card_context_1 = require("../util/employee-card-context");
const react_1 = __importDefault(require("react"));
const ui_1 = require("@app/component/ui");
const forms_1 = require("@app/component/ui/forms");
const util_1 = require("@app/util");
const user_invite_1 = require("../request/user-invite");
const error_handler_1 = require("@app/util/error-handler");
const moment_1 = __importDefault(require("moment"));
const user_invite_resend_1 = require("../request/user-invite-resend");
const store_1 = require("@app/store");
const EmployeeHeaderActivation = () => {
    const { employee, workspace } = (0, employee_card_context_1.useEmployeeCard)();
    const existingInvite = (0, store_1.useRootSelector)(state => state.workspaces?.find((ws) => ws.id === state.workspaceId)?.invites
        ?.find((_inv) => _inv?.id === employee.user?.inviteExisting));
    const invitedBefore = (0, util_1.isDefined)(existingInvite);
    const prefillEmail = () => {
        if (employee.user?.dummy) {
            return existingInvite?.email ?? '';
        }
        else {
            return employee.user?.email ?? '';
        }
    };
    const { control, handleSubmit } = (0, react_hook_form_1.useForm)({
        defaultValues: {
            email: prefillEmail(),
        },
    });
    const onSubmit = async (data) => {
        const invite = {
            workspaceId: workspace?.id ?? '',
            email: data.email,
            mergeWith: employee.user?.id,
        };
        const differentEmail = data.email !== existingInvite?.email;
        if (invitedBefore && !differentEmail) {
            const res = await (0, user_invite_resend_1.requestUserInviteResend)({ id: employee.user?.inviteExisting ?? '', workspaceId: workspace?.id ?? '' });
            if ((0, util_1.isDefined)(res)) {
                (0, error_handler_1.processSuccess)((0, util_1.t)('SUCCESS_MESSAGE.emailSent'));
            }
            return;
        }
        const res = await (0, user_invite_1.requestCreateUserInvite)(invite);
        if ((0, util_1.isDefined)(res)) {
            (0, error_handler_1.processSuccess)((0, util_1.t)('SUCCESS_MESSAGE.emailSent'));
        }
    };
    return employee.user?.dummy ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ui_1.Flex, null,
            react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_MEDIUM, weight: ui_1.Text.WEIGHTS.BOLD }, (0, util_1.t)('ACTIVATE_USER')),
            invitedBefore && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ui_1.Spacing, { type: ui_1.Spacing.TYPES.HORIZONTAL, size: ui_1.Spacing.SIZES.SIZE_8 }),
                react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_MEDIUM },
                    (0, util_1.t)('STATUS'),
                    ": ",
                    (0, util_1.t)('INVITED'),
                    " - ",
                    (0, util_1.t)('ACTIVATION_EMAIL_SENT'),
                    ": ",
                    (0, moment_1.default)(existingInvite?.lastSent).format('DD.MM.YYYY HH:mm'))))),
        react_1.default.createElement(ui_1.Spacing, { type: ui_1.Spacing.TYPES.VERTICAL, size: ui_1.Spacing.SIZES.SIZE_8 }),
        react_1.default.createElement("div", { style: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem', width: '100%' } },
            react_1.default.createElement(forms_1.TextInput, { control: control, name: 'email', testid: 'employee-activation-email-input', placeholder: (0, util_1.t)('REG_EMAIL_PLACEHOLDER_EMP') ?? '', disableLastpass: true }),
            react_1.default.createElement("div", null,
                react_1.default.createElement(ui_1.Button, { testid: 'resend-invitation-button', onClick: handleSubmit(onSubmit), style: 'CONTAINED' }, invitedBefore ? (0, util_1.t)('RESEND') : (0, util_1.t)('SEND')))),
        react_1.default.createElement(ui_1.Spacing, { type: ui_1.Spacing.TYPES.VERTICAL, size: ui_1.Spacing.SIZES.SIZE_8 }))) : null;
};
exports.EmployeeHeaderActivation = EmployeeHeaderActivation;
